import { Component } from "react";
import { FormattedRelativeTime } from "react-intl";

interface Props {
  value: number;
}

const selectUnit = (from: number) => {
  const to = Date.now();
  const durationSec = (from - to) / 1000;
  const durationSecAbs = Math.abs(durationSec);

  if (durationSecAbs < 60) {
    return {
      value: Math.trunc(durationSec),
      unit: "second" as const,
    };
  } else if (durationSecAbs < 60 * 60) {
    return {
      value: Math.trunc(durationSec / 60),
      unit: "minute" as const,
    };
  } else if (durationSecAbs < 60 * 60 * 24) {
    return {
      value: Math.trunc(durationSec / 60 / 60),
      unit: "hour" as const,
    };
  } else if (durationSecAbs < 60 * 60 * 24 * 7) {
    return {
      value: Math.trunc(durationSec / 60 / 60 / 24),
      unit: "day" as const,
    };
  } else if (durationSecAbs < 60 * 60 * 24 * 30) {
    return {
      value: Math.trunc(durationSec / 60 / 60 / 24 / 7),
      unit: "week" as const,
    };
  } else if (durationSecAbs < 60 * 60 * 24 * 365) {
    return {
      value: Math.trunc(durationSec / 60 / 60 / 24 / 30),
      unit: "month" as const,
    };
  } else {
    return {
      value: Math.trunc(durationSec / 60 / 60 / 24 / 365),
      unit: "year" as const,
    };
  }
};

// For replacement for `FormattedRelative` component of react-intl v2.
// https://formatjs.io/docs/react-intl/upgrade-guide-3x
export class FormattedRelativeTimeWithAutoUnit extends Component<Props> {
  render() {
    const { value, unit } = selectUnit(this.props.value);
    return <FormattedRelativeTime value={value} unit={unit} />;
  }
}
